import { useWSModal } from "@wingspanhq/fe-component-library";
import React, { useEffect } from "react";
import { OtpCompleteEvent } from "../../shared/utils/events/OtpCompleteEvent";
import { OtpFailEvent } from "../../shared/utils/events/OtpFailEvent";
import {
  OTP_REQUEST_EVENT,
  OtpRequestEvent
} from "../../shared/utils/events/OtpRequestEvent";
import { ModalOtpVerification } from "./ModalOtpVerification";

export const OPT_VERIFICATION_MODAL = "OPT_VERIFICATION_MODAL";

export const OptVerification: React.FC = () => {
  const modal = useWSModal(ModalOtpVerification, {
    title: "Additional verification required",
    size: "S",
    onClose: () => {
      document.dispatchEvent(new OtpFailEvent());
    }
  });

  useEffect(() => {
    const listener = (event: OtpRequestEvent) => {
      modal.open({
        apiPath: event.apiPath,
        onSuccess: () => {
          document.dispatchEvent(new OtpCompleteEvent());
        }
      });
    };

    document.addEventListener(OTP_REQUEST_EVENT, listener);

    return () => {
      document.removeEventListener(OTP_REQUEST_EVENT, listener);
    };
  }, [modal]);

  return null;
};
